(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["molten-gold-swap-stones-media"] && !Shopify.designMode) return;
  try {
    function initialiseGoldSwapFilms(root) {
  root.querySelectorAll('[data-gold-swap-film]').forEach(frame => {
    if (frame.dataset.ready) return;
    frame.dataset.ready = 'true';
    const video = frame.querySelector('video');
    if (!video) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let inView = false;
    let failed = false;
    video.controls = false;
    const showStill = () => { video.pause(); video.hidden = true; };
    const reconcile = () => {
      if (failed || reduce.matches) { showStill(); return; }
      if (inView && !document.hidden) {
        video.play().catch(showStill);
      } else video.pause();
    };
    video.addEventListener('playing', () => {
      if (reduce.matches || failed) showStill();
      else video.hidden = false;
    });
    video.addEventListener('error', () => { failed = true; showStill(); });
    const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; reconcile(); }, { threshold: 0.3 });
    observer.observe(frame);
    reduce.addEventListener('change', reconcile);
    document.addEventListener('visibilitychange', reconcile);
  });
}
initialiseGoldSwapFilms(document);
document.addEventListener('shopify:section:load', event => initialiseGoldSwapFilms(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["molten-responsive-media"] && !Shopify.designMode) return;
  try {
    (() => {
    const rootSelector = '[data-molten-responsive-media]';
    const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');

    const syncPlayback = (root) => {
      const prefersReducedMotion = motionPreference.matches;
      root.dataset.moltenReducedMotion = String(prefersReducedMotion);

      root.querySelectorAll('.molten-responsive-media__video').forEach((video) => {
        const mediaItem = video.closest('.molten-responsive-media__item');
        const hasAssignedStill = Boolean(mediaItem?.querySelector('.molten-responsive-media__poster'));

        video.autoplay = !prefersReducedMotion;

        if (prefersReducedMotion) {
          video.removeAttribute('autoplay');
          video.pause();

          if (hasAssignedStill) {
            video.style.visibility = 'hidden';
          } else {
            video.style.removeProperty('visibility');
          }

          return;
        }

        video.style.removeProperty('visibility');
        video.setAttribute('autoplay', '');

        const playback = video.play();
        if (playback && typeof playback.catch === 'function') {
          playback.catch(() => {});
        }
      });
    };

    const initialiseRoot = (root) => {
      if (!root || root.dataset.moltenResponsiveMediaMotionReady === 'true') {
        if (root) syncPlayback(root);
        return;
      }

      root.dataset.moltenResponsiveMediaMotionReady = 'true';
      const handlePreferenceChange = () => syncPlayback(root);

      if (typeof motionPreference.addEventListener === 'function') {
        motionPreference.addEventListener('change', handlePreferenceChange);
      } else {
        motionPreference.addListener(handlePreferenceChange);
      }

      root.moltenResponsiveMediaMotionCleanup = () => {
        if (typeof motionPreference.removeEventListener === 'function') {
          motionPreference.removeEventListener('change', handlePreferenceChange);
        } else {
          motionPreference.removeListener(handlePreferenceChange);
        }

        delete root.dataset.moltenResponsiveMediaMotionReady;
        delete root.moltenResponsiveMediaMotionCleanup;
      };

      syncPlayback(root);
    };

    const initialiseAll = (container = document) => {
      if (container.matches?.(rootSelector)) initialiseRoot(container);
      container.querySelectorAll?.(rootSelector).forEach(initialiseRoot);
    };

    const cleanupAll = (container) => {
      const roots = [];
      if (container.matches?.(rootSelector)) roots.push(container);
      container.querySelectorAll?.(rootSelector).forEach((root) => roots.push(root));

      roots.forEach((root) => {
        if (typeof root.moltenResponsiveMediaMotionCleanup === 'function') {
          root.moltenResponsiveMediaMotionCleanup();
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => cleanupAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["molten-stones-approved-media"] && !Shopify.designMode) return;
  try {
    function initialiseStonesFilms(root) {
  root.querySelectorAll('[data-stones-film]').forEach(frame => {
    if (frame.dataset.ready) return;
    frame.dataset.ready = 'true';
    const video = frame.querySelector('video');
    if (!video) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let inView = false;
    let failed = false;
    video.controls = false;
    const showStill = () => { video.pause(); video.hidden = true; };
    const reconcile = () => {
      if (failed || reduce.matches) { showStill(); return; }
      if (inView && !document.hidden) {
        video.play().catch(showStill);
      } else video.pause();
    };
    video.addEventListener('playing', () => {
      if (reduce.matches || failed) showStill();
      else video.hidden = false;
    });
    video.addEventListener('error', () => { failed = true; showStill(); });
    const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; reconcile(); }, { threshold: 0.3 });
    observer.observe(frame);
    reduce.addEventListener('change', reconcile);
    document.addEventListener('visibilitychange', reconcile);
  });
}
initialiseStonesFilms(document);
document.addEventListener('shopify:section:load', event => initialiseStonesFilms(event.target));
  } catch(e) { console.error(e); }
})();

})();
